import * as React from "react";

function SvgFolderIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style={{ marginTop:'-4px' }} viewBox="0 0 24 24">
            <g id="noun_open2" transform="translate(-0.5 -0.225)">
                <rect id="Rectangle_204" data-name="Rectangle 204" width="24" height="24" transform="translate(0.5 0.225)" fill="none" />
                <path id="Path_35" data-name="Path 35" d="M56.07,15.267,47.932,23.4a.839.839,0,0,1-1.187-1.187l8.138-8.138Z" transform="translate(-36.322 -9.102)" fill="#284672" />
                <path id="Path_36" data-name="Path 36" d="M20.923,11.99a.833.833,0,0,1,.855.809.789.789,0,0,1-.25.572.88.88,0,0,1-.6.237H13.2V28.183H28.592V20.87a.789.789,0,0,1,.25-.572.881.881,0,0,1,.6-.237.833.833,0,0,1,.855.809v8.122a.878.878,0,0,1-.855.809h-17.1a.878.878,0,0,1-.855-.809V12.8a.878.878,0,0,1,.855-.809Zm2.809.809a.833.833,0,0,1,.855-.809h4.86l.074,0a.872.872,0,0,1,.78.806v4.6a.788.788,0,0,1-.25.572.889.889,0,0,1-1.209,0,.789.789,0,0,1-.25-.572V13.609h-4a.881.881,0,0,1-.6-.237.789.789,0,0,1-.25-.572Z" transform="translate(-8.735 -8.831)" fill="#284672 " />
            </g>
        </svg>


    )
}
export default SvgFolderIcon;


// WEBPACK FOOTER //
// ./src/iconComponents/folderIcon.js